"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var styles_1 = require("@material-ui/core/styles");
var BaseLayout_1 = __importDefault(require("../../BaseLayout"));
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        heroContent: {
            margin: '0 auto',
            padding: theme.spacing(8, 2, 6),
        },
    });
});
var NotFoundPage = function (_a) {
    var match = _a.match;
    var classes = useStyles();
    var params = match.params;
    var shortUrl = params.shortUrl;
    var message = shortUrl ? (react_1.default.createElement(react_1.default.Fragment, null,
        "Are you sure",
        ' ',
        react_1.default.createElement("strong", null,
            document.location.host,
            "/",
            shortUrl),
        ' ',
        "was a valid GoGovSg link?")) : (react_1.default.createElement("span", null, "Are you sure you used a valid GoGovSg link?"));
    return (react_1.default.createElement(BaseLayout_1.default, null,
        react_1.default.createElement("div", { className: classes.heroContent },
            react_1.default.createElement(Typography_1.default, { variant: "h3", align: "center", color: "textPrimary", gutterBottom: true }, "How odd."),
            react_1.default.createElement(Typography_1.default, { variant: "h5", align: "center", color: "textPrimary", gutterBottom: true }, "There's nothing to be found here."),
            react_1.default.createElement(Typography_1.default, { align: "center", color: "textPrimary", gutterBottom: true }, message))));
};
exports.default = NotFoundPage;
